import { elementTypes, typesOf, type Element, type Typed } from '../../shared/elements.ts';
import { el } from './dom.ts';
import { icon } from './icons.ts';

export function elementBadge(element: Element): HTMLSpanElement {
  const badge = el('span', { className: 'element-badge' });
  applyElementBadge(badge, element);
  return badge;
}

/** Badges des types d'un monstre : un, ou deux s'il a un second type. */
export const typeBadges = (monster: Typed): HTMLSpanElement[] => typesOf(monster).map(elementBadge);

export function applyElementBadge(badge: HTMLElement, element: Element): void {
  const { label, icon: iconName, color } = elementTypes.get(element);
  badge.replaceChildren(icon(iconName), ` ${label}`);
  badge.title = `Type ${label}`;
  badge.style.setProperty('--c', color);
}
